// must match values at https://github.com/steveandkate/uno/blob/master/src/lib/urls/media/types.js
export const MEDIA_TYPE_ADAPTIVE_VIDEO = 'adaptive-video'
export const MEDIA_TYPE_AUDIO = 'audio'
export const MEDIA_TYPE_IMAGE = 'image'
export const MEDIA_TYPE_STRATEGO_APP = 'stratego-app'
export const MEDIA_TYPE_SCRATCHJR_APP = 'scratchjr-app'
export const MEDIA_TYPE_SPHERO_APP = 'sphero-app'
export const MEDIA_TYPE_VIDEO = 'video'
